import type { AvatarSize } from "@fluentui/react-components";
import { Avatar } from "@fluentui/react-components";
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { isNullOrEmptyOrWhiteSpace } from "../../utilities/StringUtilities/StringUtilities";
import { getUserPictureByIdAsync } from "../../apiRequests/graph/graph";
import { acquireAccessTokenAsync } from "../../AuthHelper";
import { graphRequest } from "../../authConfig";

export interface IUserAvatarProps {
    userId?: string;
    displayName?: string;
    className?: string;
    size?: AvatarSize;
    onClick?(ev: React.MouseEvent): void;
}

export function UserAvatar(props: Readonly<IUserAvatarProps>) {
    const { userId, displayName, className, size, onClick } = props;
    const { instance, accounts } = useMsal();
    const account = accounts[0];
    const [imageUrl, setImageUrl] = useState("");

    useEffect(() => {
        if (isNullOrEmptyOrWhiteSpace(userId) || !account) {
            return;
        }

        const fetchUserPicture = async () => {
            try {
                const accessToken = await acquireAccessTokenAsync(instance, account, graphRequest.scopes);
                if (userId) {
                    const pictureBlob = await getUserPictureByIdAsync(userId, accessToken);
                    
                    if (pictureBlob) {
                        setImageUrl(URL.createObjectURL(pictureBlob));
                    }
                }
            } catch (error) {
                console.debug("Failed to load user picture:", error);
            }
        };

        void fetchUserPicture();
    }, [userId, instance, account]);

    return (
        <Avatar 
            className={className}
            shape="circular"
            name={displayName ?? ""}
            size={size}
            image={imageUrl && userId ? { src: imageUrl } : undefined}
            onClick={onClick} 
        />
    );
}